/**
 * PGSS-5794: Lock, Unlock and Send for approval of a container run once at a time per container.
 *
 * The confirm dialog closed on the click and the row kept offering the same action until the list
 * refreshed, which only happens when the request answers. Unlock from Pending product image review
 * takes seconds (prod: 8.6 s), so the supplier clicked again and a second PUT /api/updateContainer
 * started while the first was still running. The backend now treats that second request as a no-op,
 * and this stops it being sent at all.
 *
 * The registry is module-level, not component state: the row's action cell can re-mount (table
 * refresh, menu vs inline button) while the request is still out, and it must still be refused.
 *
 * @param {string|number} shipmentId the container being changed
 * @param {function(): Promise} run the request; its promise must settle when the request does
 * @param {function(boolean)} [setBusy] told when the change starts and ends, to block the screen
 * @returns {Promise<boolean>} false when dropped because a change of this container was running
 */
const inFlight = new Set();

export function changeContainerStatusOnce(shipmentId, run, setBusy) {
  const key = String(shipmentId);
  if (inFlight.has(key)) {
    return Promise.resolve(false);
  }
  inFlight.add(key);
  setBusy?.(true);

  return Promise.resolve()
    .then(run)
    .finally(() => {
      inFlight.delete(key);
      setBusy?.(false);
    })
    .then(() => true);
}

export default changeContainerStatusOnce;
